"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const radios = document.querySelectorAll('.gr-product__tab');
  const mainElement = document.querySelector('main');
  function updateMainClass() {
    const checkedRadio = document.querySelector('.gr-product__tab:checked');
    if (checkedRadio && mainElement) {
      const value = checkedRadio.value;
      mainElement.classList.forEach(className => {
        if (className.startsWith('gr-main-product--')) {
          mainElement.classList.remove(className);
        }
      });
      mainElement.classList.add(`gr-main-product--${value}`);
    }
  }
  updateMainClass();
  radios.forEach(radio => {
    radio.addEventListener('change', updateMainClass);
  });
});

// Приймаємо повідомлення про те, що DOM завантажено повністю
// document.addEventListener("DOMContentLoaded", () => {
//   const priceElement = document.querySelector('.gr-product__price');
//   let isFixed = false;

//   function checkScrollAndResize() {
//     const scrollThreshold = window.innerHeight * 1.5;
//     const screenWidthThreshold = 1280;

//     if (window.scrollY >= scrollThreshold && window.innerWidth >= screenWidthThreshold) {
//       if (isFixed == false) {
//         addFixedClass();
//         isFixed = true;
//       }
//     } else {
//       if (isFixed) {
//         removeFixedClass();
//         isFixed = false;
//       }
//     }
//   }

//   function addFixedClass() {
//     priceElement.classList.add('gr-fixed', 'gr-fixed--show');
//   }

//   function removeFixedClass() {
//     priceElement.style.transition = 'bottom 0.5s ease-in-out'; 
//     priceElement.style.bottom = '-100px';

//     priceElement.addEventListener('transitionend', function onTransitionEnd() {
//       priceElement.classList.remove('gr-fixed', 'gr-fixed--show');
//       priceElement.style.transition = '';
//       priceElement.style.bottom = '';
//       priceElement.removeEventListener('transitionend', onTransitionEnd);
//     }, { once: true });
//   }

//   window.addEventListener('scroll', checkScrollAndResize);
//   window.addEventListener('resize', checkScrollAndResize);

//   checkScrollAndResize();
// });